"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../../common/utils/index.js"));

var _galleryComponent = require("../galleryComponent");

var _itemHoverStyleProvider = require("./itemHoverStyleProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ItemHover =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ItemHover, _GalleryComponent);

  function ItemHover() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = ItemHover.prototype;

  _proto.getHoverClass = function getHoverClass() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        forceShowHover = _this$props.forceShowHover;
    var hoverClass = ['gallery-item-hover'];

    if (styleParams.isSlider || styleParams.isSlideshow || styleParams.hasThumbnails) {
      hoverClass.push(styleParams.galleryVerticalAlign);
    }

    hoverClass.push('fullscreen-' + (styleParams.fullscreen ? 'enabled' : 'disabled'));

    if (_index["default"].isUndefined(styleParams.itemOpacity)) {
      hoverClass.push('default');
    }

    if (forceShowHover) {
      //in mobile, when item is hovered (tapped, with all the right configurations), forceShowHover is true
      hoverClass.push('force-hover');
    } else if (_index["default"].isMobile()) {
      hoverClass.push('hide-hover');
    }

    return hoverClass.join(' ');
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        shouldHover = _this$props2.shouldHover,
        imageDimensions = _this$props2.imageDimensions,
        actions = _this$props2.actions,
        idx = _this$props2.idx,
        styleParams = _this$props2.styleParams;

    if (!shouldHover) {
      return null;
    }

    var hoverClass = this.getHoverClass();

    var _ref = imageDimensions || {},
        marginLeft = _ref.marginLeft,
        marginTop = _ref.marginTop,
        width = _ref.width,
        height = _ref.height,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref, ["marginLeft", "marginTop", "width", "height"]); //width and height will be taken from the gallery.scss and not be inline


    return _react["default"].createElement("div", {
      className: hoverClass,
      key: 'item-hover-' + idx,
      "data-hook": 'item-hover-' + idx,
      "aria-hidden": true
    }, _react["default"].createElement("div", {
      style: _objectSpread({}, restOfDimensions, {}, (0, _itemHoverStyleProvider.getHoverStyle)(styleParams)),
      onTouchStart: actions.handleItemMouseDown,
      onTouchEnd: actions.handleItemMouseUp
    }, this.props.render ? _react["default"].createElement("div", {
      className: "gallery-item-hover-inner"
    }, this.props.render(this.props)) : this.props.children));
  };

  return ItemHover;
}(_galleryComponent.GalleryComponent);

exports["default"] = ItemHover;